import memoizeOne from 'memoize-one';
import { Country } from '../Country';
import RequiredLicenses from '../DataSource/RequiredLicenses';

import MarketSupply from './MarketSupply';
import ProductDataset from './ProductDataset';
import ProductDatasetSource from './ProductDatasetSource';
import ProductPrice from './ProductPrice';
import ProductSourcePrice from './ProductSourcePrice';
import ProductStatus from './ProductStatus';
import uppercaseProductValue from './uppercaseProductValue';

export default class Product {
	id: string;

	brandName: string;

	atc: string;

	marketingAuthorizationHolder: string;

	activeSubstance: string;

	validFrom: Date | null;

	validTo: Date | null;

	dosageForm: string;

	dosageStrength: string;

	packageSize: string;

	prices: ProductPrice[];

	sourcePrices: ProductSourcePrice[];

	dataset: ProductDataset;

	includedFrom: Date;

	status: ProductStatus;

	marketSupply: MarketSupply;

	constructor(
		id: string,
		brandName: string,
		atc: string,
		marketingAuthorizationHolder: string,
		activeSubstance: string,
		validFrom: Date | null,
		validTo: Date | null,
		dosageForm: string,
		dosageStrength: string,
		packageSize: string,
		prices: ProductPrice[],
		sourcePrices: ProductSourcePrice[],
		dataset: ProductDataset,
		includedFrom: Date,
		status: ProductStatus,
		marketSupply: MarketSupply
	) {
		this.id = id;
		this.brandName = brandName;
		this.atc = atc;
		this.marketingAuthorizationHolder = marketingAuthorizationHolder;
		this.activeSubstance = activeSubstance;
		this.validFrom = validFrom;
		this.validTo = validTo;
		this.dosageForm = dosageForm;
		this.dosageStrength = dosageStrength;
		this.packageSize = packageSize;
		this.prices = prices;
		this.sourcePrices = sourcePrices;
		this.dataset = dataset;
		this.includedFrom = includedFrom;
		this.status = status;
		this.marketSupply = marketSupply;
	}

	static empty(id = '') {
		return new Product(
			id,
			'',
			'',
			'',
			'',
			null,
			null,
			'',
			'',
			'',
			[],
			[],
			new ProductDataset(
				new ProductDatasetSource('', '', '', new Country('', ''), false, new RequiredLicenses(false)),
				null,
				null,
				null
			),
			new Date(0),
			new ProductStatus('', {}),
			new MarketSupply(null, null, null, null)
		);
	}

	hasAnyPrice(): boolean {
		return this.sourcePrices.length > 0;
	}

	uppercaseBrandName = memoizeOne(uppercaseProductValue);

	get uppercasedBrandName(): string | null {
		return this.uppercaseBrandName(this.brandName);
	}

	uppercaseMarketingAuthorizationHolder = memoizeOne(uppercaseProductValue);

	get uppercasedMarketingAuthorizationHolder(): string | null {
		return this.uppercaseMarketingAuthorizationHolder(this.marketingAuthorizationHolder);
	}

	uppercaseActiveSubstance = memoizeOne(uppercaseProductValue);

	get uppercasedActiveSubstance(): string | null {
		return this.uppercaseActiveSubstance(this.activeSubstance);
	}

	uppercaseDosageForm = memoizeOne(uppercaseProductValue);

	get uppercasedDosageForm(): string | null {
		return this.uppercaseDosageForm(this.dosageForm);
	}
}
